import type { State } from '../state';
import { doubleClick } from './doubleClick';
import { positionBotTarget } from './positionBotTarget';

export function showFeedbackWidget(
  state: State,
  aptWidgetContainer: HTMLDivElement | null,
  botTarget: HTMLDivElement,
  clickTarget: HTMLDivElement,
) {
  // If there's an aptWidgetContainer, double-click the div.
  // If there's no aptWidgetContainer, click only once.
  // This ensures that the feedback widget is always visible after clicking the feedback button.

  if (aptWidgetContainer) {
    positionBotTarget(botTarget, clickTarget);
    state.clickTimeout = doubleClick(botTarget);
  } else {
    positionBotTarget(botTarget, clickTarget);
    botTarget.click();
  }
}
